"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var r=require("./GraphQLError.mjs.js");exports.syntaxError=function(e,o,s){return new r.GraphQLError(`Syntax Error: ${s}`,{source:e,positions:[o]})};
//# sourceMappingURL=syntaxError.mjs.js.map
